import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BnLoadingService, EntityOrderedRequestParameters, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Observable } from "rxjs";
import { ProgramaRepasseBndes } from "src/app/model/programas-permitidos.model";
import { ProgramasPermtidosPorCestasService } from "../programas-permitidos-por-cestas.service";
import { ProgramasPermitidosPorCestasPesquisaComponent } from "../pesquisa/programas-permitidos-por-cestas-pesquisa.component";
import Utils from "src/app/shared/fgi-utils";
import { ExportService } from "src/app/shared/services/export.service";



@Component({
  selector: 'app-programas-permitidos-por-cestas-listagem',
  templateUrl: 'programas-permitidos-por-cestas-listagem.component.html',
  styleUrls: ['programas-permitidos-por-cestas-listagem.component.scss'],
  standalone: false
})

export class ProgramasPermitidosPorCestasListagemComponent {

  constructor(private programasPermitidosPorCestas: ProgramasPermtidosPorCestasService,
              private messageService: MessageChannelService,
              private modalService: BnModalMessageService,
              private ProgramasPermitidosPorCestasPesquisaComponent:ProgramasPermitidosPorCestasPesquisaComponent,
              private bnLoadingService: BnLoadingService,
              private exportService: ExportService,
              private router: Router,
              private route: ActivatedRoute
  ) {

  }

  @Input() public programasPermitidos: ProgramaRepasseBndes[] = [];
  @Input() public ideTranche: number;
  @Input() public permissaoGestorEnvio : boolean;
  public atributosOrdenacao: EntityOrderedRequestParameters;

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  public editarRepasse(item: ProgramaRepasseBndes) {
    this.router.navigate(['programas-permitidos-por-cestas/edicao-programa', item.id], {
      state: { programa: item, ideTranche: this.ideTranche }
    });
  }

  public excluiRepasse(idePrograma: number) {
    this.abreModalConfirmacao('Confirmar exclusão do programa?').then(resp => {
      if(resp === true) {
        this.programasPermitidosPorCestas.excluirRepasse(this.ideTranche, idePrograma).subscribe(() =>{
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Programa excluído com sucesso'
          })
          this.ProgramasPermitidosPorCestasPesquisaComponent.buscarTodosPorTranche();
        })
      }
    })
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.programasPermitidos = this.programasPermitidos.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  btnExportar() {
    this.bnLoadingService.bloqueiaTela();
    this.exportService.exportarProgramas(this.programasPermitidos);
    this.bnLoadingService.liberaTela();
  }

  isDestacarLinha(item: any): boolean {
    return item.aceitaBeneficiarioCpfRepasse || item.desconsiderarPrazoTotalMaximoContratual || item.abonoEcg;
  }
}
